export default "__VITE_ASSET__BwFJjT87__"